import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReviewComponent implements OnInit {
    public loading: boolean = true;
    public items: any[] = [];
    public selected: any = null;
    public filter: string = 'all';
    public opinion: string = '';
    public searchText: string = '';
    public sortKey: string = 'recent';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");

        if (!this.canAccessReview(this.service.auth.session?.role)) {
            location.href = this.roleHome(this.service.auth.session?.role);
            return;
        }

        await this.load();
    }

    public roleHome(role: string = 'researcher') {
        const normalized = this.normalizedRole(role);
        if (normalized === 'admin') return '/collections';
        if (normalized === 'reviewer') return '/review';
        return '/chat';
    }

    public canAccessReview(role: string = 'researcher') {
        return ['admin', 'reviewer'].includes(this.normalizedRole(role));
    }

    public normalizedRole(role: string = 'researcher') {
        const value = String(role || 'researcher').toLowerCase();
        if (['admin', 'administrator', 'superadmin', 'editor', 'manager', 'owner', '관리자'].includes(value)) return 'admin';
        if (['reviewer', '검수자'].includes(value)) return 'reviewer';
        return 'researcher';
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.items = data.items || [];
            if (this.items.length > 0) {
                const selectedId = this.selected?.id;
                this.selected = this.items.find((item: any) => item.id === selectedId) || this.items[0];
            } else {
                this.selected = null;
            }
        }

        this.loading = false;
        await this.service.render();
    }

    public get filteredItems() {
        const keyword = this.searchText.trim().toLowerCase();
        let rows = this.items;

        if (this.filter === 'pending') rows = rows.filter((item: any) => item.review_status === 'pending');
        else if (this.filter !== 'all') rows = rows.filter((item: any) => item.review_status === this.filter);

        if (keyword) {
            rows = rows.filter((item: any) => {
                const filename = String(item.filename || '').toLowerCase();
                const collection = String(item.collection_title || '').toLowerCase();
                const excerpt = String(item.excerpt || '').toLowerCase();
                return filename.includes(keyword) || collection.includes(keyword) || excerpt.includes(keyword);
            });
        }

        rows = [...rows];
        if (this.sortKey === 'comments') rows.sort((a: any, b: any) => (b.comment_count || 0) - (a.comment_count || 0));
        else if (this.sortKey === 'pages') rows.sort((a: any, b: any) => (b.page_count || 0) - (a.page_count || 0));
        else rows.sort((a: any, b: any) => String(b.created || '').localeCompare(String(a.created || '')));

        return rows;
    }

    public countBy(status: string) {
        if (status === 'all') return this.items.length;
        if (status === 'pending') return this.items.filter((item: any) => item.review_status === 'pending').length;
        return this.items.filter((item: any) => item.review_status === status).length;
    }

    public async setFilter(filter: string) {
        this.filter = filter;
        if (!this.filteredItems.includes(this.selected)) {
            this.selected = this.filteredItems[0] || null;
        }
        await this.service.render();
    }

    public async setSort(sortKey: string) {
        this.sortKey = sortKey;
        await this.service.render();
    }

    public async clearSearch() {
        this.searchText = '';
        await this.service.render();
    }

    public async select(item: any) {
        this.selected = item;
        this.opinion = '';
        await this.service.render();
    }

    public statusLabel(status: string) {
        if (status === 'approved') return '문제 없음';
        if (status === 'issue') return '의견 있음';
        if (status === 'rejected') return '반려 필요';
        return '대기';
    }

    public statusClass(status: string) {
        if (status === 'approved') return 'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800';
        if (status === 'issue') return 'bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800';
        if (status === 'rejected') return 'bg-red-50 text-red-700 border-red-100 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800';
        return 'bg-stone-50 text-stone-500 border-stone-100 dark:bg-stone-800 dark:text-stone-400 dark:border-stone-700';
    }

    public statusDot(status: string) {
        if (status === 'approved') return 'bg-emerald-400';
        if (status === 'issue') return 'bg-amber-400';
        if (status === 'rejected') return 'bg-red-400';
        return 'bg-stone-300 dark:bg-stone-600';
    }

    public get reviewProgress() {
        if (this.items.length === 0) return 0;
        return Math.round((this.countBy('approved') / this.items.length) * 100);
    }

    public get needsAttentionCount() {
        return this.countBy('issue') + this.countBy('rejected');
    }

    public async submit(status: string) {
        if (!this.selected) return;
        if (status !== 'approved' && !this.opinion.trim()) {
            await this.service.modal.error("검수 의견을 입력해주세요.");
            return;
        }

        const { code, data } = await wiz.call("comment", {
            document_id: this.selected.id,
            status: status,
            comment: this.opinion
        });

        if (code === 200) {
            this.opinion = '';
            await this.load();
            await this.service.modal.success("검수 의견이 저장되었습니다.");
        } else {
            await this.service.modal.error(data.message || "검수 의견 저장에 실패했습니다.");
        }
    }
}

export default PageReviewComponent;